const dynamicOutfitsOptions: Record<string, boolean> = {
  '904531': true,
  '906119': true,
  '906120': true,
  '906123': true,
  '927623': true,
  '927624': true,
  '927625': true,
  '971782': true,
  '971786': true,
  '993764': true,
  '993765': true,
  '1010232': true,
  '1010233': true,
  '1010234': true,
  '1010235': true,
  '1010237': true,
  '1010239': true,
  '1017893': true,
  '1017894': true,
  '1017895': true,
  '1017896': true,
  '1017897': true,
  '1017898': true,
  '1017899': true,
  '1017900': true,
  '1017901': true,
  '1018012': true,
  '1018013': true,
  '1018014': true,
  '1018015': true,
  '1018016': true,
  '1018066': true,
  '1018136': true,
  '1018137': true,
  '1018138': true,
  '1018189': true,
  '1018190': true,
  '1018191': true,
  '1018192': true,
  '1018193': true,
  '1018194': true,
  '1018195': true,
  '1018196': true,
  '1018197': true,
  '1018198': true,
  '1018199': true,
  '1018200': true,
  '1018201': true,
  '1018202': true,
  '1018203': true,
  '1018204': true,
  '1018205': true,
  '1018206': true,
  '1018207': true,
  '1018208': true,
  '1018209': true,
  '1018210': true,
  '1018211': true,
  '1018212': true,
  '1018213': true,
  '1018214': true,
  '1018215': true,
  '1018216': true,
  '1018217': true,
  '1018218': true,
  '1018223': true,
  '1018224': true,
  '1018225': true,
  '1018230': true,
  '1018231': true,
  '1018232': true,
  '1018233': true,
  '1018355': true,
  '1018356': true,
  '1018357': true,
  '1018358': true,
  '1018359': true,
  '1018360': true,
  '1018361': true,
  '1018362': true,
  '1018363': true,
  '1018364': true,
  '1018365': true,
  '1018366': true,
  '1018367': true,
  '1018368': true,
  '1018369': true,
  '1018370': true,
  '1018371': true,
  '1018372': true,
  '1018373': true,
  '1018374': true,
  '1018375': true,
  '1018376': true,
  '1018377': true,
  '1018378': true,
  '1018379': true,
  '1018380': true,
  '1018381': true,
  '1018382': true,
  '1018383': true,
  '1018384': true,
  '1018385': true,
  '1018386': true,
};

export default {
  dynamicOutfitsOptions,
};
